import React, { useContext } from 'react';
import { TextButton } from '@prisjakt/ui/button/variants';
import { BodySmallText, FontWeight } from '@prisjakt/ui/text/variants';
import { ActiveFilterIndicator } from './active-filter-indicator';
import { useHistory } from 'react-router';
import { ActiveFilterRow } from './styles';
import { AppContext } from '@prisjakt/ui-app-context';
import { getFilterFromLocation } from 'src/areas/product/components/product-filters/utils';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import {
  defaultHiddenListOptions,
  saveFiltersAsUserSettings,
} from '../../utils';
import { getActiveFilters } from '../../utils/filters-config';
import RouteContext from 'src/routes/context';
import { trackPriceListFilterUpdate } from 'src/areas/product/components/tracking';
import { MediumUp, MobileOnly } from 'src/ui/block';

export const ActiveFilters: React.VFC = () => {
  const { t, market } = useContext(AppContext);

  const history = useHistory();
  const location = history.location;
  const queryFilters = getFilterFromLocation(location);
  const { filters, reload } = useContext(PriceListFilterContext);
  const activeFilters = getActiveFilters(
    t,
    filters,
    defaultHiddenListOptions(market)
  ).filter(f => f.quickFilter === false);
  const { dispatch: routeDispatch } = useContext(RouteContext);

  const queryFilterOnClickHandler = () => {
    if (queryFilters) {
      const queryParams = new URLSearchParams(location.search);
      queryParams.delete('filters');
      history.push(`${location.pathname}?${queryParams.toString()}`);
    }
  };

  const filterOnClickHandler = (name: string, val: boolean) => {
    const selectedFilters = {
      ...filters,
      [name]: val,
    };
    saveFiltersAsUserSettings(selectedFilters);
    trackPriceListFilterUpdate(name, val);
    reload(selectedFilters, routeDispatch);
  };

  const clearFilters = () => {
    const updateFilters = { ...filters };

    activeFilters?.forEach(filter => {
      if (!filter.quickFilter) {
        updateFilters[filter.name] = false;
      }
    });
    saveFiltersAsUserSettings(updateFilters);
    reload(updateFilters, routeDispatch);
    queryFilterOnClickHandler();
  };

  const queryFiltersExist = queryFilters?.length > 0;
  const activeFiltersExist = activeFilters?.length > 0 || queryFiltersExist;

  return activeFiltersExist ? (
    <>
      <MediumUp>
        <ActiveFilterRow>
          <div>
            <BodySmallText weight={FontWeight.HEAVIER}>
              {t('filter', 'applied-filters.title')}:
            </BodySmallText>
          </div>

          {activeFilters?.map(f => (
            <ActiveFilterIndicator
              key={f.name}
              onClickHandler={() => filterOnClickHandler(f.name, false)}
              text={f.label}
            />
          ))}
          {queryFiltersExist && (
            <ActiveFilterIndicator
              onClickHandler={queryFilterOnClickHandler}
              text={t('store', 'brand.recommended-retailer')}
            />
          )}
          <TextButton onClick={clearFilters}>
            {t('filter', 'button.clear-filter')}
          </TextButton>
        </ActiveFilterRow>
      </MediumUp>
      <MobileOnly>
        {queryFiltersExist && (
          <ActiveFilterRow>
            <div>
              <BodySmallText weight={FontWeight.HEAVIER}>
                {t('filter', 'applied-filters.title')}:
              </BodySmallText>
            </div>
            <ActiveFilterIndicator
              onClickHandler={queryFilterOnClickHandler}
              text={t('store', 'brand.recommended-retailer')}
            />
            <TextButton onClick={queryFilterOnClickHandler}>
              {t('filter', 'button.clear-filter')}
            </TextButton>
          </ActiveFilterRow>
        )}
      </MobileOnly>
    </>
  ) : null;
};
